// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__YRyOQ","fade-in":"styles_fade-in__yc4on","container":"styles_container__3bNag"};